export default __webpack_public_path__ + "static/media/White0004.f2cb5566.png";